module.exports = __webpack_public_path__ + "img/1688693528744-IMG-20230707-WA0006.jpg.5c841ae6.webp";